import React from "react";

export const HoverInListener: React.FC<{
  onHoverIn: () => void;
  children: React.ReactNode;
}> = ({ onHoverIn, children }) => {
  const handleMouseEnter = () => {
    onHoverIn();
  };

  return <div onMouseEnter={handleMouseEnter}>{children}</div>;
};
